import React from 'react';
import { Col } from 'react-bootstrap';

export const FormCol1 = (props) => (
  <Col sm={1} lg={1} xl={1} className={props.className}>
    {props.children}
  </Col>
);

export default FormCol1;

